import React from "react";
import { useSelector } from "react-redux";
import {
    selectAllProductModal,
    updateCurrentStoreCartItemIndex,
    updateOriginalStoreCartItemIndex,
} from "../../../redux/slices/productModalSlice";
import UpdateProduct from "./UpdateProductModalOpen";

const ConnectedUpdateProductModalOpen = () => {
    const productModal = useSelector(selectAllProductModal);
    const { productModalOpen, currentProductId, currentStoreCartItemIndex } =
        productModal;

    const updateProductModalOpenProps = {
        currentProductId,
        currentStoreCartItemIndex,
        productModalOpen,
        updateCurrentStoreCartItemIndex,
        updateOriginalStoreCartItemIndex,
    };
    return <UpdateProduct {...updateProductModalOpenProps} />;
};

export default ConnectedUpdateProductModalOpen;
